import {Banner} from '@primer/react'
import {useState} from 'react'

import {BUTTON_LABELS} from '../../constants/buttons'

interface SavedViewMutationErrorBannerProps {
  message: string | null
  onRetry?: () => void
  isRetrying?: boolean
  flush?: boolean
}

function focusBannerOnMount(node: HTMLElement | null) {
  if (node) node.focus({preventScroll: true})
}

export function SavedViewMutationErrorBanner({
  message,
  onRetry,
  isRetrying = false,
  flush,
}: SavedViewMutationErrorBannerProps) {
  // Keep the last message visible while a retry is in flight so focus stays
  // on "Try again".
  const [stickyMessage, setStickyMessage] = useState<string | null>(message)
  const nextMessage = message ?? (isRetrying ? stickyMessage : null)
  if (nextMessage !== stickyMessage) setStickyMessage(nextMessage)

  if (!stickyMessage) return null

  return (
    <Banner
      ref={focusBannerOnMount}
      variant="critical"
      title={stickyMessage}
      flush={flush}
      actionsLayout={onRetry ? 'inline' : undefined}
      primaryAction={
        onRetry ? (
          <Banner.PrimaryAction onClick={onRetry} loading={isRetrying} loadingAnnouncement="Retrying">
            {BUTTON_LABELS.tryAgain}
          </Banner.PrimaryAction>
        ) : undefined
      }
    />
  )
}
